import * as Sentry from '@sentry/react';
import { saveScore } from '@/services/saveScore';
import { useAuthStore } from '@/store/authStore';
import { useGameStore } from '@/store/gameStore';

function attemptSave() {
  const { pendingSavePayload, saveState } = useGameStore.getState();
  const { isAuthenticated } = useAuthStore.getState();

  if (!pendingSavePayload || !isAuthenticated || saveState === 'saving') return;

  useGameStore.setState({ saveState: 'saving' });

  saveScore(pendingSavePayload)
    .then((success) => {
      if (success) {
        useGameStore.setState({
          saveState: 'saved',
          savedScore: pendingSavePayload.finalScore,
        });
        useGameStore.getState().clearPendingSave();
      } else {
        useGameStore.setState({ saveState: 'failed' });
        Sentry.captureMessage('Score save returned false', {
          level: 'warning',
          extra: {
            finalScore: pendingSavePayload.finalScore,
            blockCounts: pendingSavePayload.blockCounts,
          },
        });
      }
    })
    .catch((error) => {
      useGameStore.setState({ saveState: 'failed' });
      Sentry.captureException(
        error instanceof Error ? error : new Error(String(error)),
        {
          tags: { feature: 'score_save' },
          extra: {
            finalScore: pendingSavePayload.finalScore,
            blockCounts: pendingSavePayload.blockCounts,
          },
        },
      );
    });
}

useGameStore.subscribe((state, prev) => {
  if (
    state.pendingSavePayload !== prev.pendingSavePayload &&
    state.pendingSavePayload
  ) {
    attemptSave();
  }
});

useAuthStore.subscribe((state, prev) => {
  if (state.isAuthenticated && !prev.isAuthenticated) {
    attemptSave();
  }
});
